<template>
  <strapi-image
    v-if="image.image"
    :alt-fallback="`Slider Image ${image.id}`"
    :image="image.image"
    fluid
    image-class="block w-full"
  />
  <!-- the active slide sets the gallery's height, so keep one when there is no image -->
  <div v-else class="aspect-video"></div>
</template>

<script setup lang="ts">
import type { StrapiMediaGalleryImageItem } from '#variant/apollo/types/types';

defineProps<{
  image: StrapiMediaGalleryImageItem;
}>();
</script>
